<template>
  <div class="content">
    <el-tabs v-model="activeName">
      <el-tab-pane label="国际套餐" name="first">
        <InternationalProduct></InternationalProduct>
      </el-tab-pane>
      <el-tab-pane label="国际接口套餐" name="third">
        <ExternalInternationalProduct></ExternalInternationalProduct>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import InternationalProduct from "./International.vue";
import ExternalInternationalProduct from "./External.vue";
export default {
  name: "internationalProduct",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    InternationalProduct,
    ExternalInternationalProduct
  },
  created() {
  },
};
</script>